export default class SelectionsAllPurchasableController {

    constructor($scope, $rootScope, ApiSelections, $ionicLoading, $q, $state, $stateParams, $ionicScrollDelegate, ApiDashboard) {
        this.$rootScope = $rootScope;
        this.$ionicLoading = $ionicLoading;
        this.$state = $state;
        this.ApiSelections = ApiSelections;
        this.selections = [];
        this.selectionsPromise = $q.defer();
        this.$stateParams = $stateParams;
        this.showStartupHelpWizard = $stateParams.showHelp;
        this.$ionicScrollDelegate = $ionicScrollDelegate;
        this.ApiDashboard = ApiDashboard;
    }

    init() {

        this.$ionicLoading.show({
            template: '<spinner-advinda></spinner-advinda>'
        });

        this.ApiSelections.getSelections().then((res) => {
            if (typeof res != 'undefined') {
                this.selections = res;
                this.selections.forEach((selection) => {
                    delete selection.relatedSelection;
                });
                this.hideContainerFromPackages();
                this.selectionsPromise.resolve(res);
                this.selections.loaded = true;
                this.$ionicLoading.hide();
            } else {
                this.$ionicLoading.hide();
            }
        });

        this.isStartupDisplayed = this.ApiDashboard.isStartupDisplayed;
    }

    /**
     * Hard-code to remove 2 container packages `Other Investors` & `Pension & Insurance`
     * @link https://toolchain.logicline.de/jira/browse/AIC-953
     * @return {void}
     */
    hideContainerFromPackages() {
        let container = ['Pension & Insurance', 'Other Institutionals'];
        this.selections = this.selections.filter(s => !container.includes(s.selectionName));
    }

    filterPension(selection) {
        return selection.subtitle && selection.subtitle.includes('Pension') && !selection.subtitle.includes('Insurance')
    }

    filterInsurance(selection) {
        return selection.subtitle && !selection.subtitle.includes('Pension') && selection.subtitle.includes('Insurance');
    }

    filterBoth(selection) {
        return selection.subtitle && selection.subtitle.includes('Pension') && selection.subtitle.includes('Insurance');
    }

    filterOther(selection) {
        return selection.subtitle && !selection.subtitle.includes('Pension') && !selection.subtitle.includes('Insurance');
    }

    setSearchPerformedSignal() {

        this.$ionicScrollDelegate.scrollTop();
        this.$rootScope.$broadcast('searchPerformed');
        
    };
}



/** WEBPACK FOOTER **
 ** ./src/app/components/selections/selectionsAllPurchasable.controller.js
 **/